import styled from "styled-components";
import { HorizontalMain } from "../../style/default";

export const MyHorizontalScrollView = styled(HorizontalMain)`
	justify-content: space-between;
	padding: 1rem;
	> div {
		display: flex;
		align-items: center;

		button {
			background-color: "transparent";
			color: "#000";
			border: 1px solid #fff;
			font-size: 15px;
			display: flex;
			align-items: center;
			border-radius: 4px;
			min-height: 36px;
			padding: 5px;
			&:focus {
				border: 1px solid #ddd;
			}
		}

		> input {
			min-height: 38px;
			padding: 2px 8px;
			border-color: hsl(0, 0%, 80%) !important;
			margin-left: 1rem;
			-moz-appearance: textfield;
			&::-webkit-inner-spin-button,
			&::-webkit-outer-spin-button {
				-webkit-appearance: none;
				margin: 0;
			}
			&:focus {
				box-shadow: none;
				border-color: #2684ff !important;
			}
		}
		> div {
			width: 100%;
		}
		> div:not(:first-child) {
			margin-left: 1rem;
		}
	}

	> div:last-child {
		width: 100%;

		> div {
			width: 300px;
			padding: 0.35rem;
		}
	}
`;
export const Tab = styled.div`
	z-index: 1;
	> div {
		background-color: #fff;
	}
	a {
		font-size: 1rem;
		color: #3f4254;
	}
	a.active {
		color: #000;
		font-weight: bold;
	}
`;

export const Container = styled.div`
	padding: 1rem;
	margin-bottom: 1rem;
`;

export const CompanyImage = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;

	> h4 {
		margin-right: 2rem;
	}
	> form {
		position: relative;
		float: left;

		> img {
			opacity: 1;
			margin-right: 1rem;
			width: 75px;
			height: 75px;
			height: auto;
			transition: 0.5s ease;
			backface-visibility: hidden;
			border-radius: 5rem;
		}
		> label {
			transition: 0.5s ease;
			opacity: 0;
			position: absolute;
			top: 50%;
			left: 50%;
			cursor: pointer;
			transform: translate(-67%, -50%);
			cursor: pointer;
			padding: 0.5rem;
			z-index: 999;
			> svg {
				border-radius: 5rem;
				width: 55px;
				height: 55px;
				cursor: pointer;
			}
			:hover {
				opacity: 1;
				cursor: pointer;
			}
		}

		:hover {
			> img {
				opacity: 0.45;
				cursor: pointer;
			}
			> div {
				opacity: 1;
				cursor: pointer;
			}
		}
	}
`;

export const WppImage = styled.div`
	width: 100%;
	display: flex;
	align-items: center;

	> form {
		position: relative;
		> h4 {
			font-size: 16px;
		}
		> img {
			opacity: 1;
			margin-right: 1rem;
			min-width: 190px;
			min-height: 190px;
			width: 190px;
			height: 190px;
			transition: 0.5s ease;
			backface-visibility: hidden;
			image-rendering: optimizeSpeed;
		}
		> label {
			transition: 0.5s ease;
			opacity: 0;
			margin: 0;
			position: absolute;
			width: 190px;
			height: 190px;
			top: 56%;
			left: 45%;
			cursor: pointer;
			transform: translate(-50%, -50%);
			cursor: pointer;
			z-index: 999;
			display: flex;
			> svg {
				border-radius: 5rem;
				width: 190px;
				height: 80px;
				cursor: pointer;
				justify-self: center;
				align-self: center;
			}
			:hover {
				opacity: 1;
				cursor: pointer;
			}
		}

		:hover {
			> img {
				opacity: 0.45;
				cursor: pointer;
			}
			> div {
				opacity: 1;
				cursor: pointer;
			}
		}
	}
`;

export const CBody = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	> div {
		display: flex;
		flex-direction: row;
		align-items: ${(props) => props.basic && "center"};
		> label {
			text-align: start;
			display: flex;
			align-items: center;
			margin-bottom: 0 !important;
		}
		> input[type="checkbox"] {
			cursor: pointer;
			width: 15px;
			height: 15px;
			margin-left: 0.5rem;
		}

		> section {
			width: 100%;
		}
	}
	> label {
		width: 100%;
		text-align: start;
		display: flex;
		margin-top: 1rem;
		margin-bottom: 10px;
		align-items: center;
		> input {
			cursor: pointer;
			width: 15px;
			height: 15px;
			margin-left: 1rem;
		}
		> div {
			display: flex;
			margin-left: auto;
		}
	}
`;
export const Title = styled.h3`
	font-size: 18px;
	font-weight: 450;
	display: flex;
`;

export const BusinessDays = styled.div`
	display: flex;
	flex-direction: column !important;
	> label {
		margin-bottom: 1.8rem;
		font-size: 17px;
	}
	> div {
		display: flex;
		flex-direction: row;
		padding: 0 !important;
		justify-content: ${(props) => (props.notEvely ? "" : "space-evenly")};
		align-items: center;

		> label {
			cursor: pointer;
			align-self: center;
			margin-left: ${(props) => (props.notEvely ? "0.5rem" : "")};
			margin-bottom: 0 !important;
			display: flex;
			align-items: center;
		}

		> input[type="number"] {
			width: 70px;
			margin-left: 1rem;
			border: 1px solid silver !important;
			outline: 0 !important;
		}
		> input[type="checkbox"] {
			height: 15px;
			width: 15px;
			cursor: pointer;
		}
	}
`;

export const BusinessVerificator = styled.div`
	display: flex;
	flex-direction: column !important;
	> label {
		margin-bottom: 1.8rem;
		font-size: 17px;
	}
	> div {
		padding: 0 !important;
		justify-content: ${(props) => (props.notEvely ? "" : "space-evenly")};
		align-items: center;

		> .default-number {
			margin-top: 15px;
			display: block;

			> label {
				display: block;
			}

			> input {
				width: 100%;
				border: 1px solid silver !important;
				outline: 0 !important;
				margin-top: 5px;
				padding: 8px;
			}
		}

		> div {
			width: 100%;
			align-items: center;
			display: flex;

			> label {
				cursor: pointer;
				align-self: center;
				margin-left: ${(props) => (props.notEvely ? "0.5rem" : "")};
				margin-bottom: 0 !important;
				display: flex;
				align-items: center;
			}

			> input[type="number"] {
				width: 70px;
				margin-left: 1rem;
				border: 1px solid silver !important;
				outline: 0 !important;
			}
			> input[type="checkbox"] {
				height: 18px;
				width: 18px;
				margin-left: 1rem;
				cursor: pointer;
			}
		}
	}
`;

export const MyInput = styled.input`
	height: 32px;
	padding: 1rem;
	border: 0 !important;
	cursor: text;
	width: 100%;
	background-color: #e8f0fe;
	outline: 0 !important;

	:disabled {
		background-color: #f0f0f0;
		cursor: not-allowed;
	}
`;

export const EditC = styled.div`
	display: flex;
	justify-content: space-around;
	align-items: center;
	margin-left: ${(props) => props.left && "auto"};
	> button {
		margin-left: 0.5rem;
	}
`;

export const ConfirmOperation = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`;
